import locationService from './ws';

export default locationService;